import { Component, OnInit } from '@angular/core';

import { ClinicStatus } from '../../models/clinic-status.model';
import { ClinicStatusService } from '../../services/clinic-status.service';
import { DisasterStatus } from '../../models/disaster-status';

@Component({
  selector: 'app-clinic-status-list',
  templateUrl: './clinic-status-list.component.html',
  styleUrls: ['./clinic-status-list.component.css']
})
export class ClinicStatusListComponent implements OnInit {

  consultation: boolean;
  electricity: boolean;
  waterSupply: boolean;
  phone: boolean;

  initialList: ClinicStatus[];
  clinicStatusList: ClinicStatus[];

  constructor(private clinicStatusService: ClinicStatusService) { }

  ngOnInit() {
    this.clinicStatusService.getClinicStatusList().subscribe(clinicStatusList => {
      this.clinicStatusList = clinicStatusList;
      this.initialList = clinicStatusList;
    });
  }

  // ngOnitで動作しない為、メソッド化する。
  getSyllabaryIds(): number[] {
    const ids = this.clinicStatusList.map(status => status.syllabaryId); // SELECT

    return Array.from(new Set(ids)); // 重複削除
  }

  getClinicStatusList(key: number) {
    return this.clinicStatusList.filter(status => status.syllabaryId == key);
  }

  search() {
    this.clinicStatusList = this.initialList;

    if (this.consultation) {
      this.clinicStatusList = this.clinicStatusList.filter(status => status.consultation == DisasterStatus.Possible);
    }

    if (this.electricity) {
      this.clinicStatusList = this.clinicStatusList.filter(status => status.electricity == DisasterStatus.Possible);
    }

    if (this.waterSupply) {
      this.clinicStatusList = this.clinicStatusList.filter(status => status.waterSupply == DisasterStatus.Possible);
    }

    if (this.phone) {
      this.clinicStatusList = this.clinicStatusList.filter(status => status.phone == DisasterStatus.Possible);
    }
  }
}
